import Link from '@app/components/Link';
import useSimpleCart from '@app/hooks/useSimpleCart';
import { Box } from '@theme-ui/components';
import cookie from 'js-cookie';
import { useEffect } from 'react';

import { SHOP_STORE_CODE_COOKIE } from '@app/helpers/localization';
import CartMessages from '@app/pages/Cart/Cart.messages';
import { COOKIE_DOMAIN } from '@config/common.config';
import { useIntl } from 'react-intl';
import { NINavigationFullCart } from '../webex-ni/icons';
import styles from './CartButton.styles';

export const BASKET_COUNTER_COOKIE = 'basketcounter';

const CartButton = () => {
  const { itemsCount, storeConfig } = useSimpleCart();
  const shopStoreCodeCookie = cookie.get(SHOP_STORE_CODE_COOKIE);
  const storeCode = storeConfig?.storeCode;
  const { formatMessage } = useIntl();

  useEffect(() => {
    cookie.set(BASKET_COUNTER_COOKIE, itemsCount?.toString() ?? '0');

    // Quick fix to make sure the `store_view_code` cookie is set when switching from NI v2 to NI v1.
    // Without it, checkout in NI v1 won’t work properly.
    // Remove this once there’s a better solution or the migration to NI v2 is done.
    if (!shopStoreCodeCookie && storeCode) {
      cookie.set(SHOP_STORE_CODE_COOKIE, storeCode, {
        domain: COOKIE_DOMAIN,
      });
    }
  }, [itemsCount, storeCode, shopStoreCodeCookie]);

  const showCounter = Boolean(itemsCount);

  return (
    <Link css={styles.wrapper} to="/:language/shop/cart/">
      <NINavigationFullCart
        title={formatMessage(CartMessages.title)}
        style={{ width: '32px', color: 'black' }}
      />
      {showCounter && (
        <Box data-testid="basket-counter" css={styles.bubble}>
          {itemsCount}
        </Box>
      )}
    </Link>
  );
};

export default CartButton;
